import * as React from "react"
import { SDKContext } from "./SDKContext"
import { useAuthEventsCB } from "./useAuthEventsCB"
import { useWsEventsCB } from "./useWsEventsCB"
import { useMediaEventCB } from "./useMediaEventCB"
import { useWatchPartyEventsCB } from "./useWatchPartyEventsCB"
import { SDKContextProviderProps } from "./types"
import { useShowEventsCB } from "./useShowEventsCB"
import { useNativeEventsCB } from "./useNativeEventsCB"
import { useAvatarEventsCB } from "./useAvatarEventsCB"

const MeetOnline = window.MeetOnline
const EventType = MeetOnline?.EventType

export const MeetClientHandlerProvider = (props: SDKContextProviderProps) => {
  const _meetingClient = React.useContext(SDKContext)

  const authEventsCB = useAuthEventsCB()
  const wsEventsCB = useWsEventsCB()
  const mediaEventsCB = useMediaEventCB()
  const watchPartyEventsCB = useWatchPartyEventsCB()
  const showEventsCB = useShowEventsCB()
  const avatarEventsCB = useAvatarEventsCB()
  const nativeEventsCB = useNativeEventsCB()

  React.useEffect(() => {
    _meetingClient?.on(EventType.Auth, authEventsCB)
    _meetingClient?.on(EventType.WebSocket, wsEventsCB)
    _meetingClient?.on(EventType.Media, mediaEventsCB)
    _meetingClient?.on(EventType.WatchParty, watchPartyEventsCB)
    _meetingClient?.on(EventType.Shows, showEventsCB)
    _meetingClient?.on(EventType.Avatars, avatarEventsCB)
    _meetingClient?.on(EventType.Native, nativeEventsCB)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_meetingClient])

  return <>{props.children}</>
}
